import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { NotificationDeliveryListState } from './NotificationDeliveryListState';
import { NotificationDeliveryListItem } from './NotificationDeliveryListItem';
import { LoadMoreButton } from '../../../commonv3/components/atoms/buttons/LoadMoreButton';
import { InfiniteScroll } from '../../../commonv3/components/atoms/scroll/InfiniteScroll';
import { restrictAccessForUser } from '../../../commonv3/hooks/restrictAccessForUser';
import { CheckBoxSelectInput } from '../../components/molecules/forms/CheckBoxSelectInput';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import './notificationDeliveryListPage.module.scss';

export const NotificationDeliveryListPage = observer(() => {
  restrictAccessForUser();
  useNavigation(NavigationSpecs.side());

  const { pageState } = useLocalStore(() => ({
    pageState: new NotificationDeliveryListState(),
  }));

  useEffect(() => {
    pageState.init();
  }, []);

  const totalPages = pageState.totalPages;

  const options = [
    { label: '重要なお知らせのみ', value: 'important' },
    { label: 'SHElikesアップデート情報', value: 'update_info' },
    { label: 'SHE運営からのお知らせ', value: 'management_from' },
  ];
  const breadCrumbItems = [{ text: 'お知らせ' }];

  return (
    <Page id="notification-list-page">
      <BreadCrumb items={breadCrumbItems} hasHome />
      <PageHeader title="MESSAGE" testId="page-header-of-message" />
      {totalPages && (
        <div styleName="page-body">
          <div styleName="selector-container">
            <div styleName="selector-container-text">表示の絞り込み</div>
            <CheckBoxSelectInput
              widthType="s"
              options={options}
              values={pageState.notificationCategories}
              className="location-selector"
              onChange={(v) => {
                pageState.setNotificationCategories(v);
              }}
            />
          </div>
          <div styleName="notification-list-items" data-value="notification-list-items">
            {totalPages.map((notificationDeliveries) =>
              notificationDeliveries.map((notificationDelivery) => (
                <NotificationDeliveryListItem
                  key={notificationDelivery.id}
                  notificationDelivery={notificationDelivery}
                />
              ))
            )}
          </div>
          {(pageState.loading || pageState.hasNextPage) &&
            (totalPages.length < 2 ? (
              <LoadMoreButton loading={pageState.loading} fetchNextPage={pageState.fetchNextPage} />
            ) : (
              <InfiniteScroll loading={pageState.loading} fetchNextPage={pageState.fetchNextPage} />
            ))}
        </div>
      )}
    </Page>
  );
});
